import { render, staticRenderFns } from "./CouresList.vue?vue&type=template&id=73cf147e"
import script from "./CouresList.vue?vue&type=script&lang=js"
export * from "./CouresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports